const emptyText =
  'No addresses were found. <br> This could be a new address, or you may need to check the spelling.';
const widgets = [];

function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function initAddressFinder() {
  // console.log('initAddressFinder');
  const apiKey = window.addressFinderApiKey;

  if (!apiKey) {
    return;
  }

  document.querySelectorAll('[data-addressfinder]').forEach((el) => {
    const elId = el.getAttribute('id') || el.getAttribute('name');
    const modelName = el.getAttribute('data-address-model');

    // console.log('elId', elId);
    // console.log('modelName', modelName);

    // create the widget
    widgets[elId] = new AddressFinder.Widget(el, apiKey, 'AU', {
      address_params: {
        gnaf: '1',
      },
      manual_style: true,
      byline: false,
      empty_content: emptyText,
      container: el.closest('.field__main'),
    });

    widgets[elId].on('address:select', function (fullAddress, metaData) {
      // console.log('address:select', fullAddress, metaData);

      // get state id
      let stateId = null;
      switch (metaData.state_territory) {
        case 'ACT':
          stateId = 1;
          break;
        case 'NSW':
          stateId = 2;
          break;
        case 'NT':
          stateId = 3;
          break;
        case 'QLD':
          stateId = 4;
          break;
        case 'SA':
          stateId = 5;
          break;
        case 'TAS':
          stateId = 6;
          break;
        case 'VIC':
          stateId = 7;
          break;
        case 'WA':
          stateId = 8;
          break;
      }

      const assignValues = {
        addressLine1: metaData.address_line_1,
        addressLine2: metaData.address_line_2,
        locality: toTitleCase(metaData.locality_name),
        administrativeArea: metaData.state_territory,
        postalCode: metaData.postcode,
        countryCode: 'AU',
      };

      Object.keys(assignValues).forEach((key) => {
        let fieldName = '[name="' + modelName + '[' + key + ']"]';
        if (modelName === 'address') {
          fieldName = '[name="' + key + '"]';
        }
        if (document.querySelector(fieldName)) {
          document.querySelector(fieldName).value = assignValues[key];
        }
      });
    });
  });
}

function downloadAddressFinder() {
  if (
    document.querySelectorAll('[data-addressfinder]').length &&
    typeof AddressFinder === 'undefined'
  ) {
    const script = document.createElement('script');
    script.src = 'https://api.addressfinder.io/assets/v3/widget.js';
    script.async = true;
    script.onload = initAddressFinder;
    document.body.appendChild(script);
  } else {
    initAddressFinder();
  }
}

(function () {
  const addressFinderOn = true;
  if (addressFinderOn) {
    document.addEventListener('DOMContentLoaded', downloadAddressFinder);
  }
})();
